export const CHANGE_USERNAME_OPEN_MODAL = "CHANGE_USERNAME_OPEN_MODAL";
export const CHANGE_USERNAME_CLOSE_MODAL = "CHANGE_USERNAME_CLOSE_MODAL";

export const CHANGE_USERNAME_UPDATE_REQUEST = "CHANGE_USERNAME_UPDATE_REQUEST";
export const CHANGE_USERNAME_UPDATE_RESULT = "CHANGE_USERNAME_UPDATE_RESULT";

